module.exports = __webpack_public_path__ + "static/media/meta-quest-icon.6297a7ce.png";